

















































import { app } from '../main'
import ProductsApi from '@cms-labs/typescript-api/products'
import { Component, Vue, Prop } from 'vue-property-decorator'
import {
  ProductItemPublic,
  ProductCollectionItemPublic
} from '@cms-labs/typescript-api/products/types'
import store from '../store'

import { BButton, BModal, BIconCartCheck } from 'bootstrap-vue'

@Component({
  components: { BButton, BModal, BIconCartCheck }
})
export default class AddToCartButton extends Vue {
  @Prop({ required: true })
  private product!: ProductCollectionItemPublic

  @Prop({ required: false, default: 1 })
  private productQuantity!: number

  @Prop({ required: false, default: false })
  private disabled!: boolean

  @Prop({ required: false, default: false })
  private padded!: boolean

  private hideModal () {
    this.$bvModal.hide(`modal-${this.product.uuid}`)
  }

  private async addProductToCart (): Promise<void> {
    // @TODO Put this function in a "util" file cause it is being used
    // in other places as well... copy and pasted
    const http = new ProductsApi(app)
    // @ts-ignore
    const localItem = this.product
    try {
      const cloudItem: ProductItemPublic = await http.getProductInstance(localItem.uuid)
      if (
        this.productQuantity &&
        cloudItem.stock &&
        this.productQuantity > cloudItem.stock
      ) {
        store.cart.removeItem(localItem.uuid)
        this.$bvToast.toast(
          'No hay suficientes unidades disponibles de este producto.', {
            title: `Sólo quedan ${cloudItem.stock} unidades del producto: ${localItem.name}.`,
            variant: 'danger',
            autoHideDelay: 10000
          }
        )
        return
      }
      if (
        localItem.name !== cloudItem.name ||
        localItem.price !== cloudItem.price ||
        localItem.discount_pct !== cloudItem.discount_pct
      ) {
        store.cart.removeItem(localItem.uuid)
        this.$bvToast.toast(
          'Porfavor vuelva a agregar los productos en su carrito', {
            title: 'La info. de su(s) producto(s) está desactualizada.',
            variant: 'danger',
            autoHideDelay: 10000
          }
        )
        return
      }
      store.cart.addItem(this.product, this.productQuantity)
      this.$bvModal.show(`modal-${this.product.uuid}`)
    } catch (error) {
      if (error.response.status === 404) {
        this.$bvToast.toast(
          'Porfavor vuelva a agregar los productos en su carrito', {
            title: `El producto: ${localItem.name} ya no está disponible.`,
            variant: 'danger',
            autoHideDelay: 10000
          }
        )
      }
    }
  }
}
